export default "__VITE_ASSET__CjGftZke__"